var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.teacher
    ? _c(
        "v-card",
        {
          staticClass: "soli-round w-full",
          attrs: {
            flat: "",
            outlined: _vm.$vuetify.breakpoint.smAndUp && !_vm.floating,
          },
          nativeOn: {
            click: function ($event) {
              return _vm.$emit("click")
            },
          },
        },
        [
          _c(
            "v-container",
            [
              _c(
                "SoliAvatarBtn",
                {
                  attrs: {
                    outlined: _vm.outlined,
                    avatar: _vm.teacher.profile_photo_url,
                    title: _vm.teacher.name,
                    size: "64",
                    blueShadow: "",
                    ripple: false,
                    moreInfo: !!(_vm.expand && _vm.teacher.bio),
                    disabled: _vm.disabled,
                    autoHideImage: "",
                    subtitleBottom: `${
                      _vm.teacher.pronouns ? _vm.teacher.pronouns + " | " : ""
                    }${
                      _vm.teacher.instruments.length > 3
                        ? _vm.teacher.instruments
                            .filter((e, idx) => 3 > idx)
                            .map((i) => " " + i.name) + "..."
                        : _vm.teacher.instruments.map((i) => " " + i.name)
                    }`,
                  },
                  on: {
                    click: function ($event) {
                      ;[_vm.$emit("input", _vm.teacher), (_vm.dialog = true)]
                    },
                  },
                },
                [
                  [
                    _vm.teacher.certification_level
                      ? _c("SoliTeacherCert", {
                          attrs: { teacher: _vm.teacher },
                        })
                      : _vm._e(),
                  ],
                  _vm._v(" "),
                  _vm.selectedInstrument
                    ? _c("TeacherInfo", {
                        attrs: {
                          teacher: _vm.teacher,
                          selectedInstrument: _vm.selectedInstrument,
                        },
                        on: {
                          close: function ($event) {
                            _vm.dialog = false
                          },
                        },
                        model: {
                          value: _vm.dialog,
                          callback: function ($$v) {
                            _vm.dialog = $$v
                          },
                          expression: "dialog",
                        },
                      })
                    : _vm._e(),
                ],
                2
              ),
              _vm._v(" "),
              _vm.value && _vm.hasOpenTimes
                ? _c(
                    "v-container",
                    { staticClass: "pa-2" },
                    _vm._l(_vm.intervalGroup, function (intervals) {
                      return _c(
                        "div",
                        { key: intervals.assignment_id },
                        [
                          intervals.openTimes.length
                            ? _c("SoliTime", {
                                ref: "soliTime",
                                refInFor: true,
                                attrs: {
                                  label: "Start Time",
                                  narrow: "",
                                  intervals: intervals.openTimes,
                                  loading: _vm.loading,
                                  select: false,
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.$emit("inputTime", {
                                      teacher: _vm.teacher,
                                      time: $event,
                                      assignment_id: intervals.assignment_id,
                                    })
                                  },
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      )
                    }),
                    0
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.value && !_vm.hasOpenTimes && !_vm.loading
                ? _c(
                    "v-container",
                    [
                      _c("v-col", { staticClass: "soli-grey py-0" }, [
                        _vm._v(
                          "\n                Sorry, no times are available for this selection\n            "
                        ),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          !_vm.hideDivider && (_vm.$vuetify.breakpoint.xs || _vm.floating)
            ? _c("v-divider", { staticClass: "mt-4" })
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }